/* =============================================================================
   [KI] Sticky Add to Cart — mobile PDP purchase bar (controller)
   -----------------------------------------------------------------------------
   Drives snippets/ki-sticky-atc.liquid. Mirrors the on-page Protocol Selector
   (.protocol-selector .ps-card) — each card is a variant with id / name /
   duration / price / image — into a persistent bottom bar + swap sheet, adds via
   /cart/add.js, then shows the mini-cart. Falls back to the product's selected
   variant when no selector is present.

   Custom element so a fetch-and-swap (kiPdpSwap replaces #main-content) re-runs
   connectedCallback on the fresh node automatically — no manual re-init.

   Reveal model (per the design): the bar is hidden over the hero + selector
   (those carry their own CTAs) and only rises once the buyer has scrolled past
   the selector; it tucks away while the sheet / mini-cart is open.
   ============================================================================= */

(function () {
  'use strict';

  if (customElements.get('ki-sticky-atc')) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function txt(el) { return el ? (el.textContent || '').trim() : ''; }

  function money(cents) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        var fmt = (window.theme && window.theme.moneyFormat) || undefined;
        return window.Shopify.formatMoney(cents, fmt);
      }
    } catch (e) { /* fall through */ }
    return null;
  }

  var CHECK_SVG = '<svg class="kiatc__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';
  var OPT_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>';

  class KiStickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      // Adopt to <body> so position:fixed is viewport-relative even if a section
      // ancestor has a transform (which would otherwise become the containing
      // block and pin the bar inside the section). Clear any stale instance left
      // in <body> by a previous page / fetch-and-swap first. Appending re-fires
      // connectedCallback, but the _init guard above makes that a no-op.
      if (this.parentNode !== document.body) {
        var self0 = this;
        Array.prototype.forEach.call(document.querySelectorAll('body > ki-sticky-atc'), function (el) {
          if (el !== self0) el.remove();
        });
        document.body.appendChild(this);
      }

      var q = this.querySelector.bind(this);
      this.bar       = q('[data-kiatc-bar]');
      this.cta       = q('[data-kiatc-cta]');
      this.label     = q('[data-kiatc-label]');
      this.thumb     = q('[data-kiatc-thumb]');
      this.variantEl = q('[data-kiatc-variant]');
      this.descEl    = q('[data-kiatc-desc]');
      this.priceEl   = q('[data-kiatc-price]');
      this.chev      = q('[data-kiatc-chev]');
      this.swapBtn   = q('[data-kiatc-swap]');
      this.scrim     = q('[data-kiatc-scrim]');
      this.sheet     = q('[data-kiatc-sheet]');
      this.opts      = q('[data-kiatc-opts]');
      this.sheetAdd  = q('[data-kiatc-sheet-add]');
      this.minicart  = q('[data-kiatc-minicart]');
      this.mcThumb   = q('[data-kiatc-mc-thumb]');
      this.mcName    = q('[data-kiatc-mc-name]');
      this.mcMeta    = q('[data-kiatc-mc-meta]');
      this.mcQty     = q('[data-kiatc-mc-qty]');
      this.mcPrice   = q('[data-kiatc-mc-price]');
      this.mcSubtotal= q('[data-kiatc-mc-subtotal]');
      this.mcCheckout= q('[data-kiatc-mc-checkout]');
      this.mcContinue= q('[data-kiatc-mc-continue]');
      this.incartMeta= q('[data-kiatc-incart-meta]');
      this.incartView= q('[data-kiatc-incart-view]');
      this.incartCo  = q('[data-kiatc-incart-checkout]');
      this.toast     = q('[data-kiatc-toast]');
      this.toastMsg  = q('[data-kiatc-toast-msg]');
      this.toastAct  = q('[data-kiatc-toast-action]');

      if (!this.bar || !this.cta) return;

      var d = this.dataset;
      this.cfg = {
        addUrl:    d.cartAddUrl || (ROOT + 'cart/add.js'),
        cartUrl:   d.cartUrl || (ROOT + 'cart'),
        checkout:  ROOT + 'checkout',
        notifyUrl: d.notifyUrl || '',
        section:   d.section || '',
        defaultId: d.defaultVariantId || '',
        available: d.available === '1',
        tButton:   d.tButton || 'In den Warenkorb',
        tAdded:    d.tAdded || 'Hinzugefügt',
        tNotify:   d.tNotify || 'Benachrichtige mich',
        tSheetCta: d.tSheetCta || 'Hinzufügen',
        tIncart:   d.tIncart || 'Im Warenkorb'
      };

      // Optional per-duration label overrides (theme settings). Applied over the
      // protocol-card values in buildModel(); blank fields fall back to the card.
      this.overrides = {};
      try {
        var ovEl = q('[data-kiatc-overrides]');
        if (ovEl) this.overrides = JSON.parse(ovEl.textContent) || {};
      } catch (e) { this.overrides = {}; }

      // Product metafield text (variant pack_* → protocol metaobject), resolved in
      // Liquid. The ONLY text sources for the cards are: override → these → blank.
      this.metafields = {};
      try {
        var mfEl = q('[data-kiatc-metafields]');
        if (mfEl) this.metafields = JSON.parse(mfEl.textContent) || {};
      } catch (e) { this.metafields = {}; }

      this.options = [];
      this.selected = null;
      this.inCart = false;
      this.busyTimer = null;
      this.manualPin = false;

      this.buildModel();
      this.paintBar();
      this.bindEvents();
      this.setupReveal();

      // Late safety net: protocol-selector may parse after this element upgrades.
      if (!this.options.length || this.options.length < 2) {
        var self = this;
        var retry = function () { self.buildModel(); self.paintBar(); };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', retry, { once: true });
        window.addEventListener('load', retry, { once: true });
      }
    }

    /* ── Read the live protocol cards into an options model ─────────────── */
    buildModel() {
      var ov = this.overrides || {};
      var mf = this.metafields || {};
      var cards = document.querySelectorAll('.protocol-selector .ps-card');
      var opts = [];
      cards.forEach(function (card) {
        var id = card.getAttribute('data-variant-id');
        if (!id) return;
        var durNum = txt(card.querySelector('.ps-card__duration-num'));
        var durUnit = txt(card.querySelector('.ps-card__duration-unit'));
        // Duration drives the bar's main line and the big numeral in the sheet —
        // read from the (format-aware) card.
        var barLabel = durNum ? (durUnit ? (durNum + ' ' + durUnit) : durNum) : '';
        // Name + description come from EXACTLY two sources, in order:
        //   1. theme-setting override (kiatc_ovr_*)
        //   2. product metafield (variant pack_* → protocol metaobject)
        // …and nothing else. No card text, no section settings, no hardcoded
        // strings. If both are blank, the field is blank.
        var ovd = ov[durNum] || {};
        var mfd = mf[durNum] || {};
        var name = ovd.name || mfd.name || '';
        var desc = ovd.desc || mfd.desc || '';
        var img = card.querySelector('.ps-card__img');
        opts.push({
          card: card,
          id: id,
          name: name,
          barLabel: barLabel || name,
          durNum: durNum,
          durUnit: durUnit,
          desc: desc,
          priceEl: card.querySelector('.ps-card__price-main'),
          imgEl: img,
          recommended: card.classList.contains('ps-card--featured'),
          available: true
        });
      });

      // ── Fallback source: the PDP hero picker ──────────────────────────
      // When [KI] Protocol Selector runs its eCommerce layout, the page has no
      // .protocol-selector cards at all — the Method section replaces them and
      // the hero picker becomes the only selector on the page. Read it instead,
      // so the bar keeps its full three-option swap sheet rather than
      // collapsing to the single server-rendered option below.
      //
      // Field mapping differs from ps-card: the hero prints one duration string
      // ("90 Tage") where the card has separate number and unit elements, so we
      // split on the first space. A card with no space ("90") still yields a
      // usable number and an empty unit.
      if (!opts.length) {
        document.querySelectorAll('.product-detail .pd-po').forEach(function (card) {
          var id = card.getAttribute('data-variant-id');
          if (!id) return;
          var dur = txt(card.querySelector('.pd-po__dur'));
          // the card label may add a second part after „ · “ (Vegetarian: „9 Monate · 3 Protokolle“, 27 Oct 2026) – the bar,
          // its sheet and the cart line show only the supply („9 Monate“), which fits the one-line bar on phones
          dur = dur.split(' · ')[0];
          var sp = dur.indexOf(' ');
          var durNum = sp === -1 ? dur : dur.slice(0, sp);
          var durUnit = sp === -1 ? '' : dur.slice(sp + 1);
          var ovd = ov[durNum] || {};
          var mfd = mf[durNum] || {};
          var flag = card.querySelector('.pd-po__flag');
          opts.push({
            card: card,
            id: id,
            name: ovd.name || mfd.name || '',
            barLabel: dur || ovd.name || mfd.name || '',
            durNum: durNum,
            durUnit: durUnit,
            desc: ovd.desc || mfd.desc || txt(card.querySelector('.pd-po__qty')),
            priceEl: card.querySelector('.pd-po__price'),
            imgEl: card.querySelector('.pd-po__media img'),
            recommended: !!(flag && txt(flag)),
            available: card.getAttribute('data-available') !== 'false'
          });
        });
      }

      // Fallback: no selector → single option from the server-rendered bar.
      if (!opts.length && this.cfg.defaultId) {
        opts.push({
          card: null,
          id: this.cfg.defaultId,
          name: txt(this.variantEl),
          barLabel: txt(this.variantEl),
          durNum: '', durUnit: '',
          desc: '',
          priceEl: null,
          imgEl: (this.thumb && this.thumb.tagName === 'IMG') ? this.thumb : null,
          recommended: false,
          available: this.cfg.available,
          staticPrice: this.priceEl ? this.priceEl.innerHTML : ''
        });
      }

      this.options = opts;

      // Preserve a previously-chosen id across rebuilds; else recommended; else first.
      var keep = this.selected && this.selected.id;
      this.selected =
        (keep && this.findOpt(keep)) ||
        opts.filter(function (o) { return o.recommended; })[0] ||
        opts[0] || null;
    }

    findOpt(id) {
      return this.options.filter(function (o) { return o.id === id; })[0] || null;
    }

    /* Read the freshest id/price/img from the card (it mutates on format toggle). */
    live(o) {
      if (!o) return o;
      if (o.card) {
        var id = o.card.getAttribute('data-variant-id');
        if (id) o.id = id;
        if (o.priceEl) o.price = txt(o.priceEl);
        if (o.imgEl) o.img = o.imgEl.getAttribute('src') || o.imgEl.src;
      } else {
        o.price = txt(this.priceEl) || o.price;
        if (o.imgEl) o.img = o.imgEl.getAttribute('src') || o.imgEl.src;
      }
      return o;
    }

    /* ── Paint the collapsed bar from the selected option ───────────────── */
    paintBar() {
      var o = this.live(this.selected);
      if (!o) return;
      if (this.thumb && this.thumb.tagName === 'IMG' && o.img) this.thumb.src = o.img;
      if (this.variantEl) this.variantEl.textContent = o.barLabel || o.name || '';
      if (this.descEl) { this.descEl.textContent = o.desc || ''; this.descEl.style.display = o.desc ? '' : 'none'; }
      if (this.priceEl && o.price) this.priceEl.innerHTML = '<b>' + o.price + '</b>';

      // Single option → no swap affordance.
      var multi = this.options.length > 1;
      if (this.chev) this.chev.style.display = multi ? '' : 'none';
      if (this.swapBtn) {
        this.swapBtn.disabled = !multi;
        this.swapBtn.style.cursor = multi ? '' : 'default';
        this.swapBtn.setAttribute('aria-label', o.barLabel || o.name || '');
      }

      if (o.available === false) this.setState('soldout');
      else this.setState('default');
    }

    setState(s) {
      this.state = s;
      this.bar.dataset.state = s;
      if (s === 'loading') this.cta.setAttribute('aria-busy', 'true');
      else this.cta.removeAttribute('aria-busy');

      if (!this.label) return;
      if (s === 'default' || s === 'loading') {
        this.label.textContent = this.cfg.tButton;
      } else if (s === 'added') {
        this.label.innerHTML = CHECK_SVG + this.cfg.tAdded;
      } else if (s === 'soldout') {
        this.label.textContent = this.cfg.tNotify;
      } else if (s === 'incart') {
        var o = this.selected;
        if (this.incartMeta) this.incartMeta.textContent = o ? ('· ' + (o.barLabel || o.name)) : '';
      }
    }

    /* ── Reveal once scrolled past the selector ─────────────────────────── */
    setupReveal() {
      var self = this;
      // Reveal anchor: the bar rises once the buyer has scrolled past whatever
      // owns the purchase decision. Editorial layout → the protocol selector.
      // eCommerce layout → there is no selector, so the hero picker is what the
      // bar must not duplicate; without this fallback the anchor would be null
      // and the bar would revert to the crude "one viewport scrolled" rule.
      this.anchor =
        document.querySelector('.protocol-selector') ||
        document.querySelector('.product-detail[data-layout="ecommerce"] .pd-form') ||
        document.getElementById('ProductInfo-' + this.cfg.section) ||
        null;

      this.checkReveal = function () {
        if (self.manualPin) return;
        var on;
        if (self.anchor) {
          var r = self.anchor.getBoundingClientRect();
          on = r.bottom < (window.innerHeight * 0.6);
        } else {
          on = window.scrollY > window.innerHeight; // fallback: past one viewport
        }
        self.reveal(on);
      };
      window.addEventListener('scroll', this.checkReveal, { passive: true });
      window.addEventListener('resize', this.checkReveal);
      this.checkReveal();
    }

    reveal(on) {
      if (on === this._revealed) return;
      this._revealed = on;
      this.classList.toggle('is-revealed', on);
    }

    tuck(on) { this.classList.toggle('is-tucked', on); }

    /* ── Events ─────────────────────────────────────────────────────────── */
    bindEvents() {
      var self = this;

      this.cta.addEventListener('click', function () {
        var s = self.state;
        if (s === 'loading' || s === 'added') return;
        if (s === 'soldout') { self.notify(); return; }
        self.addFlow();
      });

      if (this.swapBtn) this.swapBtn.addEventListener('click', function () {
        if (self.options.length > 1) self.openSheet();
      });

      if (this.scrim) this.scrim.addEventListener('click', function () { self.closeSheet(); self.closeMiniCart(); });

      if (this.opts) this.opts.addEventListener('click', function (e) {
        var btn = e.target.closest('.kiatc__opt');
        if (!btn) return;
        self.pick(btn.getAttribute('data-id')); // live-mirror, keep sheet open
      });

      if (this.sheetAdd) this.sheetAdd.addEventListener('click', function () { self.closeSheet(); self.addFlow(); });

      if (this.mcCheckout) this.mcCheckout.addEventListener('click', function () { window.location.href = self.cfg.checkout; });
      if (this.mcContinue) this.mcContinue.addEventListener('click', function () { self.closeMiniCart(); });
      if (this.incartView) this.incartView.addEventListener('click', function () { self.viewCart(); });
      if (this.incartCo) this.incartCo.addEventListener('click', function () { window.location.href = self.cfg.checkout; });
      if (this.toastAct) this.toastAct.addEventListener('click', function () { self.viewCart(); });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        if (self.sheet && self.sheet.classList.contains('is-open')) self.closeSheet();
        if (self.minicart && self.minicart.classList.contains('is-open')) self.closeMiniCart();
      });

      // The KI mini-cart and the theme's Cart Drawer are separate surfaces that
      // coexist (sticky-add opens ours; the header icon / protocol cards open the
      // theme's). If the shopper opens the theme drawer while ours is up, dismiss
      // ours so the two overlays never stack.
      document.addEventListener('cart-drawer:open', function () {
        self.closeMiniCart();
        self.closeSheet();
      });
    }

    /* ── Swap sheet ─────────────────────────────────────────────────────── */
    openSheet() {
      this.buildSheetOpts();
      this.sheet.hidden = false;
      this.minicart.hidden = true;
      var self = this;
      requestAnimationFrame(function () {
        self.sheet.classList.add('is-open');
        self.scrim.classList.add('is-open');
        self.tuck(true);
      });
      this.swapBtn.setAttribute('aria-expanded', 'true');
    }
    closeSheet() {
      if (!this.sheet) return;
      this.sheet.classList.remove('is-open');
      if (!this.minicart || !this.minicart.classList.contains('is-open')) {
        this.scrim.classList.remove('is-open');
        this.tuck(false);
      }
      this.swapBtn.setAttribute('aria-expanded', 'false');
    }

    buildSheetOpts() {
      if (!this.opts) return;
      var self = this;
      var html = this.options.map(function (o) {
        self.live(o);
        var sel = self.selected && o.id === self.selected.id;
        return '<button type="button" class="kiatc__opt' + (sel ? ' is-selected' : '') +
          '" role="radio" aria-checked="' + (sel ? 'true' : 'false') + '" data-id="' + o.id + '">' +
          (o.recommended ? '<span class="kiatc__opt-rec">' + (self.recLabel()) + '</span>' : '') +
          (o.durNum ? '<span class="kiatc__opt-dur"><b>' + o.durNum + '</b><i>' + (o.durUnit || '') + '</i></span>' : '<span></span>') +
          '<span class="kiatc__opt-body"><span class="kiatc__opt-name">' + (o.name || '') + '</span>' +
          (o.desc ? '<span class="kiatc__opt-meta">' + o.desc + '</span>' : '') + '</span>' +
          '<span class="kiatc__opt-price">' + (o.price || '') + '</span>' +
          '<span class="kiatc__opt-check">' + OPT_CHECK + '</span>' +
        '</button>';
      }).join('');
      this.opts.innerHTML = html;
      this.updateSheetCta();
    }

    recLabel() {
      // Reuse the recommended badge text already rendered on the featured card.
      var rec = document.querySelector('.protocol-selector .ps-card--featured .ps-card__recommended span');
      return rec ? txt(rec) : 'Empfohlen';
    }

    pick(id) {
      var o = this.findOpt(id);
      if (!o) return;
      this.selected = o;
      this.inCart = false;
      // mirror selection in the sheet
      var opts = this.opts.querySelectorAll('.kiatc__opt');
      opts.forEach(function (b) {
        var on = b.getAttribute('data-id') === id;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      this.updateSheetCta();
      this.paintBar(); // live-mirror into the bar behind the sheet
    }

    updateSheetCta() {
      if (this.sheetAdd && this.selected) {
        this.sheetAdd.textContent = this.cfg.tSheetCta + ' ' + (this.selected.barLabel || this.selected.name || '');
      }
    }

    /* ── Add to cart ────────────────────────────────────────────────────── */
    notify() {
      if (this.cfg.notifyUrl) { window.location.href = this.cfg.notifyUrl; return; }
      this.showToast('<b>' + this.cfg.tNotify + '</b>', false);
    }

    addFlow() {
      var o = this.live(this.selected);
      if (!o || !o.id) return;
      if (o.available === false) { this.notify(); return; }

      this.setState('loading');
      var self = this;
      var fd = new FormData();
      fd.append('id', o.id);
      fd.append('quantity', '1');
      // Ask Shopify to re-render the cart-bubble section so the header count can
      // be updated exactly the way the theme's own ProductForm does it.
      fd.append('sections', 'cart-bubble');
      fd.append('sections_url', window.location.pathname);

      fetch(this.cfg.addUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fd
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = (res.body && (res.body.description || res.body.message)) || 'Could not add to cart.';
            throw new Error(msg);
          }
          self.onAdded(res.body);
        })
        .catch(function (err) {
          self.setState(o.available === false ? 'soldout' : 'default');
          self.showToast('<b>' + (err && err.message ? err.message : 'Fehler') + '</b>', false);
        });
    }

    onAdded(item) {
      var self = this;

      // Brief ✓ on the button, then revert to the normal purchasable bar. The
      // success DRAWER (mini-cart) is the only post-add surface — we intentionally
      // do NOT use a separate compact "in-cart" bar state, to avoid two competing
      // patterns / CTAs at the bottom.
      this.setState('added');
      clearTimeout(this.busyTimer);
      this.busyTimer = setTimeout(function () { self.setState('default'); }, 1150);

      // Update the header cart count by swapping in the freshly-rendered
      // cart-bubble section (same approach as the theme's ProductForm). Then let
      // the rest of the theme know an item was added — this event does NOT open
      // the theme drawer (only recipient-form + the quiz sheet listen), so our
      // mini-cart stays the single success surface.
      this.injectBubble(item && item.sections);
      try {
        document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true, detail: { product: item } }));
        // Keep the theme's (hidden) cart drawer content current so a later
        // "View cart" opens a correct drawer. cart:refresh re-renders the drawer;
        // it does NOT open it (the theme uses it the same way on cart errors).
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (e) { /* noop */ }

      // Pull the cart for the mini-cart subtotal, then open the drawer.
      fetch(this.cfg.cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.openMiniCart(cart); })
        .catch(function () { self.openMiniCart(null); });
    }

    injectBubble(sections) {
      try {
        if (!sections || !sections['cart-bubble']) return;
        var container = document.getElementById('cart-drawer-toggle');
        if (!container) return;
        var parsed = new DOMParser().parseFromString(sections['cart-bubble'], 'text/html');
        var src = parsed.querySelector('.thb-item-count');
        var dest = container.querySelector('.thb-item-count');
        if (src && dest) dest.replaceWith(src);
        else if (src) container.appendChild(src);
      } catch (e) { /* noop */ }
    }

    /* ── Mini-cart drawer ───────────────────────────────────────────────── */
    openMiniCart(cart) {
      var o = this.selected;
      if (o) {
        if (this.mcThumb && o.img) this.mcThumb.src = o.img;
        if (this.mcName) this.mcName.textContent = o.barLabel || o.name || '';
        if (this.mcMeta) this.mcMeta.textContent = o.desc || '';
        if (this.mcPrice && o.price) this.mcPrice.textContent = o.price;
      }
      var subtotal = (cart && money(cart.total_price)) || (o && o.price) || '';
      if (this.mcSubtotal && subtotal) this.mcSubtotal.textContent = subtotal;
      if (this.mcQty) this.mcQty.textContent = 'Qty 1';

      this.sheet.hidden = true;
      this.minicart.hidden = false;
      var self = this;
      requestAnimationFrame(function () {
        self.minicart.classList.add('is-open');
        self.scrim.classList.add('is-open');
        self.tuck(true);
      });
    }
    closeMiniCart() {
      if (!this.minicart) return;
      this.minicart.classList.remove('is-open');
      if (!this.sheet || !this.sheet.classList.contains('is-open')) {
        this.scrim.classList.remove('is-open');
        this.tuck(false);
      }
      // Drawer is the only post-add surface — the bar stays / returns to its
      // normal purchasable state (no compact in-cart bar).
      if (this.state === 'incart') this.setState('default');
    }

    /* ── View cart → theme cart drawer (fallback: cart page) ────────────── */
    viewCart() {
      if (!this.openThemeDrawer()) window.location.href = this.cfg.cartUrl;
    }
    openThemeDrawer() {
      var drawer = document.querySelector('cart-drawer');
      var toggle = document.getElementById('cart-drawer-toggle');
      if (!drawer || !toggle) return false; // drawer disabled → caller navigates to /cart
      // Refresh the drawer so it reflects the current cart, then open it exactly
      // the way the header cart icon does (the click handler lives on the toggle,
      // and preventDefaults its own navigation). Our cart-drawer:open listener
      // then dismisses the KI overlays so nothing stacks.
      try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) { /* noop */ }
      toggle.click();
      return true;
    }

    /* ── Toast ──────────────────────────────────────────────────────────── */
    showToast(html, withAction) {
      if (!this.toast) return;
      this.toastMsg.innerHTML = html;
      this.toastAct.hidden = !withAction;
      this.toast.classList.add('is-open');
      clearTimeout(this._toastT);
      var self = this;
      this._toastT = setTimeout(function () { self.toast.classList.remove('is-open'); }, withAction ? 3600 : 2400);
    }

    disconnectedCallback() {
      if (this.checkReveal) {
        window.removeEventListener('scroll', this.checkReveal);
        window.removeEventListener('resize', this.checkReveal);
      }
      clearTimeout(this.busyTimer);
      clearTimeout(this._toastT);
    }
  }

  customElements.define('ki-sticky-atc', KiStickyAtc);
})();
